import { cx } from "@emotion/css";
import { PropTypes } from "prop-types";

const OrderSummaryLineLayout = ({ contentClassName, titleSection, contentSection }) => (
  <>
    <span className="col-3 mb-2 px-0 text-color-grey400">{titleSection}</span>
    <span className={cx("mb-2 px-0 text-fw-bold", contentClassName)}>{contentSection}</span>
  </>
);

OrderSummaryLineLayout.defaultProps = {
  contentClassName: "col-9",
};

OrderSummaryLineLayout.propTypes = {
  contentClassName: PropTypes.string,
  titleSection: PropTypes.node.isRequired,
  contentSection: PropTypes.node.isRequired,
};

export default OrderSummaryLineLayout;
